export class RegExpUtility {
  public static escape(value: string): string {
    return value.replace(/[\s#$()*+,.?[\\\]^{|}-]/g, '\\$&');
  }
}
